import PropTypes from 'prop-types'
import React from 'react'

function FundingStatusBadge ({ statusText, className }) {
  return (
    <div className={className}>{statusText}</div>
  )
}

FundingStatusBadge.propTypes = {
  statusText: PropTypes.string,
  className: PropTypes.string
}
FundingStatusBadge.defaultProps = {}

export default FundingStatusBadge
